import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SettingsI } from './types'
import { MONTHS, BUDGET_BASED } from '../../resources/constants'
import { transformMonths } from '../../resources/functions';

export const initialState: SettingsI = {
  date_time: "",
  logo: '',
  /*accouting: {
    first_month_of_fiscal_year: null,
    first_month_of_income_tax_year: null,
    budget_based_on: null
  },
  sales: {
    state_tax_account_id: null
  },*/
  accouting: {
    transaction_activity_status: 0,
    third_party_steps_completed: 0,
    bank_account_count: 0,
    gross_sale_account_id: null,
    user_id: null,
    location_branch_id: null,
    sales_activity_count: 0,
    state_tax_account_id: null,
    is_beginning_balance_exists: 0,
    is_coa_modified: 0,
    opening_balance_created_at: null,
    opening_balance_skipped_at: null,
    bs_refresh_in_progress: null,
    bs_refresh_started_at: null,
    bs_refresh_total: null,
    bs_refresh_completed: null,
    accounting_type: 0,
    erp_in_use: false
  },
  primary_sales_account: {
    name: "",
    account: null,
    description: ""
  },
  primary_state_tax_account: {
    name: "",
    account: null,
    description: ""
  },
  qbo_session_expired: true,
  qbo_last_login: null,

  sage_session_expired: true,
  sage_pay_last_login: null,
  third_party_steps_completed: 0,
  third_party_imported_step: 0,
  third_party_imported_start_date: null,
  third_party_imported_end_date: null,
  is_qbd_import: false,
  bs_regeneration_failed: false,
  bs_regeneration_failed_month: null,
  bs_regeneration_failed_msg: null,

  bank_account_match: true,
  opening_balance_exists: false,
  monthClosedBetweenDepositAndSalesMismatch: false,
  budget_settings: {
    budget_based_on: null,
    first_month_of_fiscal_year: null,
    first_month_of_income_tax_year: null,
    user_id: null
  },
  system_access: true,
  fisrtLoginCheck: 0,
  qbd_key_status: null
}

const selectedValue = (source: any[], value: number) => {
  const data = source.filter((record: any) => +record['value'] === value)
  return data.length && data[0] || null;
}

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    // Reset the settings slice to initialState. Useful to avoid stale persisted values
    resetSettings(state) {
      // Assign all top-level fields from initialState to ensure a full reset
      state.date_time = initialState.date_time;
      state.logo = initialState.logo;
      state.accouting = { ...initialState.accouting };
      state.primary_sales_account = { ...initialState.primary_sales_account };
      state.primary_state_tax_account = { ...initialState.primary_state_tax_account };
      state.qbo_session_expired = initialState.qbo_session_expired;
      state.qbo_last_login = initialState.qbo_last_login;
      state.sage_session_expired = initialState.sage_session_expired;
      state.sage_pay_last_login = initialState.sage_pay_last_login;
      state.third_party_steps_completed = initialState.third_party_steps_completed;
      state.third_party_imported_step = initialState.third_party_imported_step;
      state.third_party_imported_start_date = initialState.third_party_imported_start_date;
      state.third_party_imported_end_date = initialState.third_party_imported_end_date;
      state.third_party_imported_start_date = initialState.third_party_imported_start_date;
      state.is_qbd_import = initialState.is_qbd_import;
      state.bs_regeneration_failed = initialState.bs_regeneration_failed;
      state.bs_regeneration_failed_month = initialState.bs_regeneration_failed_month;
      state.bs_regeneration_failed_msg = initialState.bs_regeneration_failed_msg;
      state.bank_account_match = initialState.bank_account_match;
      state.opening_balance_exists = initialState.opening_balance_exists;
      state.monthClosedBetweenDepositAndSalesMismatch = initialState.monthClosedBetweenDepositAndSalesMismatch;
      state.budget_settings = { ...initialState.budget_settings };
      state.system_access = initialState.system_access;
      state.fisrtLoginCheck = initialState.fisrtLoginCheck;
      state.qbd_key_status = initialState.qbd_key_status;
    },
    updateSettings(state, action: PayloadAction<any>) {
      const account = action.payload.user_account_settings;
      const isQbdImport = !!action.payload.is_qbd_import;
    
      const erpInUse = !isQbdImport && (account.qbo_realm_id != null || account.is_third_party_account_enabled == 1 ||
        account.third_party_steps_completed > 0 || account.third_party_imported_step > 0);
      const manualStarted = account.is_coa_modified == 1 || account.is_beginning_balance_exists == 1;
      const accountingType = erpInUse ? (account.accounting_type || 2) : manualStarted ? 1 : 3;
      state.accouting = {
        transaction_activity_status: action.payload.user_account_settings.transaction_activity_status || 0,
        bank_account_count: action.payload.user_account_settings.bank_account_count || 0,
        gross_sale_account_id: action.payload.user_account_settings.gross_sale_account_id,
        user_id: action.payload.user_account_settings.user_id,
        location_branch_id: action.payload.user_account_settings.location_branch_id,
        sales_activity_count: action.payload.user_account_settings.sales_activity_count || 0,
        state_tax_account_id: action.payload.user_account_settings.state_tax_account_id,
        is_beginning_balance_exists: action.payload.user_account_settings.is_beginning_balance_exists,
        is_coa_modified: action.payload.user_account_settings.is_coa_modified,
        opening_balance_created_at: action.payload.opening_balance_created_at,
        opening_balance_skipped_at: action.payload.opening_balance_skipped_at,
        bs_refresh_in_progress: action.payload.user_account_settings.bs_refresh_in_progress,
        bs_refresh_started_at: action.payload.user_account_settings.bs_refresh_started_at ?? null,
        bs_refresh_total: action.payload.user_account_settings.bs_refresh_total ?? null,
        bs_refresh_completed: action.payload.user_account_settings.bs_refresh_completed ?? null,
        accounting_type: accountingType,
        erp_in_use: erpInUse,
        third_party_steps_completed: action.payload.user_account_settings.third_party_steps_completed
      }
      state.primary_sales_account = action.payload.primary_sales_account
      state.primary_state_tax_account = action.payload.primary_state_tax_account
      state.bank_account_match = action.payload.bank_account_match
      state.is_qbd_import = !!action.payload.is_qbd_import
      state.bs_regeneration_failed = !!action.payload.bs_regeneration_failed
      state.bs_regeneration_failed_month = action.payload.bs_regeneration_failed_month || null
      state.bs_regeneration_failed_msg = action.payload.bs_regeneration_failed_msg || null
      state.opening_balance_exists = action.payload.opening_balance_exists || false
      state.monthClosedBetweenDepositAndSalesMismatch = action.payload.month_closed_between_deposit_and_sales_mismatch || false
      state.budget_settings = {
        budget_based_on: selectedValue(BUDGET_BASED, action.payload.budget_settings.budget_based_on),
        first_month_of_fiscal_year: selectedValue(transformMonths(), action.payload.budget_settings.first_month_of_fiscal_year),
        first_month_of_income_tax_year: selectedValue(transformMonths(), action.payload.budget_settings.first_month_of_income_tax_year),
        user_id: action.payload.budget_settings.user_id
      },
      state.qbo_session_expired = !!action.payload.user_account_settings.qbo_session_expired,
      state.qbo_last_login = action.payload.user_account_settings.qbo_last_login,
      state.third_party_steps_completed = action.payload.user_account_settings.third_party_steps_completed,
      state.third_party_imported_step = action.payload.user_account_settings.third_party_imported_step || 0,
      state.third_party_imported_start_date = action.payload.user_account_settings.tp_import_start_date || null,
      state.third_party_imported_end_date = action.payload.user_account_settings.tp_import_end_date || null,
      state.third_party_imported_start_date = action.payload.user_account_settings.tp_import_start_date || null,
      state.sage_session_expired = !!action.payload.user_account_settings.sage_session_expired,
      state.sage_pay_last_login = action.payload.user_account_settings.sage_pay_last_login || null,

      state.fisrtLoginCheck = action.payload.user_account_settings.transaction_activity_status ? action.payload.user_account_settings.transaction_activity_status : 0,
      state.qbd_key_status = action.payload.user_account_settings.qbd_key||null
    },
    updateQuickBookSettings(state, action: PayloadAction<any>) {
      state.qbo_session_expired = !!action.payload.user_account_settings.qbo_session_expired,
      state.qbo_last_login = action.payload.user_account_settings.qbo_last_login,
      state.third_party_steps_completed = action.payload.user_account_settings.third_party_steps_completed,
      state.third_party_imported_step = action.payload.user_account_settings.third_party_imported_step || 0,
      state.third_party_imported_start_date = action.payload.user_account_settings.tp_import_start_date || null,
      state.third_party_imported_end_date = action.payload.user_account_settings.tp_import_end_date || null
    },
    updateOpeningBalanceExists(state, action: PayloadAction<any>) {
      state.opening_balance_exists = action.payload.opening_balance_exists || false
    }
    /*updateAccounting(state, action: PayloadAction<any>) {
      state.accouting.first_month_of_fiscal_year = selectedValue(transformMonths(), action.payload.first_month_of_fiscal_year)
      state.accouting.first_month_of_income_tax_year = selectedValue(transformMonths(), action.payload.first_month_of_income_tax_year)
      state.accouting.budget_based_on = selectedValue(BUDGET_BASED, action.payload.budget_based_on)
    },
    updateAccountingSales(state, action: PayloadAction<any>) {
      //console.log(action.payload);
      state.sales.state_tax_account_id = action.payload
    },*/
  },
})

export const { reducer } = settingsSlice

export const { resetSettings, updateSettings, updateOpeningBalanceExists, updateQuickBookSettings /*updateAccounting, updateAccountingSales*/ } = settingsSlice.actions
